<template>
  <fullscreen-view class="email-creation">
    <template #header>
      <span v-if="error" class="error">{{ error }}</span>
      <span v-if="notice" class="notice">{{ notice }}</span>
      <button class="button cancel-button" @click="$emit('closeEmailCreationModal')">cancel</button>
    </template>
    <template #content>
      <sb-loading-icon v-if="loading" class="loading"/>
      <div v-else id="bee-plugin-container"></div>
    </template>
  </fullscreen-view>
</template>

<script>
import { FullscreenView } from "@springbig/sb-components";
import Bee from "@mailupinc/bee-plugin";
import { mapGetters } from "vuex";
import { beeAPI } from "../../../services/api/beeAPI.js";

export default {
  props: {
    campaign: Object,
    email: Object,
    selectedEmailTemplate: Object
  },

  name: "email-creation",

  data() {
    return {
      error: null,
      loading: false,
      notice: null
    }
  },

  async created() {
    const token = await beeAPI.getAuthToken();

    const beeConfig = {
      uid: this.currentMerchant.uuid,
      container: "bee-plugin-container",
      language: "en-US",
      customCss: `${window.location.origin}/email_template_plugin.css`,
      mergeTags: [
        {
          name: "customer first name",
          value: "%{MEMBER_FIRST_NAME}",
          previewValue: "John"
        },
        {
          name: "member wallet link",
          value: "%{MEMBER_LINK}",
          previewValue: "view your wallet"
        },
        {
          name: "merchant name",
          value: "%{MERCHANT_FULL_NAME}",
          previewValue: "Joe's Store"
        }
      ],
      onSaveAsTemplate: async (jsonLayout) => {
        this.notice = "saving..."
        try {
          let response = await beeAPI.postCreateMerchantEmailTemplate(jsonLayout)
          if (response.status == "200") {
            this.error = null
            this.notice = "template created successfully"
          } else {
            this.notice = null
            this.error = response.data
          }
        } catch(e){
          this.notice = null
          this.error = "error, please refresh or contact support";
        }
      },
      onSave: (jsonLayout, htmlLayout) => {
        this.loading = true;
        const params = {
          "layout_json": jsonLayout,
          "layout_html": htmlLayout,
          "campaign_id": this.campaign.id
        }
        try {
          beeAPI.putUpdateEmailTemplate(this.campaign.id, jsonLayout, htmlLayout);
          // We need to wait 5 seconds in order to get the preview_image generated
          // during these 5 seconds there is a sidekiq worker that builds the preview
          setTimeout(async () => {
            const { specific_campaign_template } = await beeAPI.getEmailTemplates(this.campaign.id);
            this.$emit("update:selectedEmailTemplate", specific_campaign_template);
            this.$emit('closeEmailCreationModal');
            this.$emit('toggleSend');
          }, 5000);
        } catch(e){
          this.notice = null
          this.error = "error, please refresh or contact support";
        }
      }
    }
    const beeInstance = new Bee(token);

    beeInstance.start(beeConfig, this.selectedEmailTemplate.layout_json);
  },

  components: {FullscreenView},

  computed: {
    ...mapGetters(['currentMerchant'])
  }
}
</script>

<style scoped>
.email-creation {
  display: flex;
  flex-direction: column;
}

.email-creation >>> .button.cancel-button {
  background-color: transparent;
  color: #128ff9;
  font-family: "AileronThin";
  font-size: 18px;
  height: 58px;
  line-height: 1em;
  margin: 15px 30px 15px 0;
}

.email-creation >>> header {
  align-items: center;
  background-color: #128ff933;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 100px;
}

.email-creation >>> .content {
  display: flex;
  flex-flow: row wrap;
  height: 100%;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  width: 100%;
}

#bee-plugin-container {
  flex: 1;
  height: 100%;
}

.email-creation .loading {
  height: auto;
  width: 450px;
}
</style>